import React from "react"

export default function Checkbox({ label, ...props }: any) {
  // make custom checkbox with cirular border
  return (
    <label className="flex items-center gap-[10px]">
      <input type="checkbox" {...props} />
      <p>{label}</p>
    </label>
  )
}
